import React from 'react';

import classNames from 'classnames';

import * as styles from './faq.module.css';
import { FaqItem } from './faqItem';
import { FaqSchemaHeader } from './faqSchemaHeader';
import { blocksToText } from '../../utils/portableTextToPlainText';
import { PortableText } from '../portableText';

import './faq.scss';

export function FaqBlock({ categories, showCategoryNames, subtitle, title }) {
	const faqClickHandler = (faqBlock) => {
		const answer = faqBlock.querySelector('.faq-answer');
		const arrow = faqBlock.querySelector('.faq-arrow');

		if (answer.style.maxHeight) {
			answer.style.maxHeight = null;
		} else {
			answer.style.maxHeight = answer.scrollHeight + 24 + 'px';
		}

		arrow.classList.toggle('down');
	};

	// build an array of all possible faq schema data
	const faqSchemaData = categories?.map((category) => {
		const faqItemsSchema =
			category.faqItems?.map((faq) => {
				return `{
        "@type": "Question",
        "name": "${faq.question}",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "${blocksToText(faq.answer)}"
        }
      }`;
			}) || [];

		// build an array of all possible subcategory faq schema data
		const faqSubcategoriesSchema =
			category.subcategories?.map((subcategory) => {
				return subcategory.faqItems?.map((faq) => {
					return `{
          "@type": "Question",
          "name": "${faq.question}",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "${blocksToText(faq.answer)}"
          }
        }`;
				});
			}) || [];

		const mainEntity = faqItemsSchema.concat(faqSubcategoriesSchema);

		return mainEntity;
	});

	return (
		<>
			<FaqSchemaHeader faqSchemaData={faqSchemaData} />
			<div className={classNames('faq', styles.moduleContainer)}>
				{(title || subtitle) && (
					<div className='faq-container-header'>
						{title && (
							<PortableText
								className='faq-headline dark-green'
								blocks={title}
								style={{ marginBottom: '0.75em' }}
							/>
						)}
						{subtitle && <PortableText blocks={subtitle} />}
					</div>
				)}
				<div
					className={classNames('faq-container', styles.faqContainer)}
				>
					{categories?.map((faqGroup) => {
						return (
							<div
								key={faqGroup._id}
								className='faq-group-container'
							>
								{showCategoryNames && (
									<div className='faq-group-header'>
										<h3 className='body-display'>
											{faqGroup.category}
										</h3>
									</div>
								)}
								{faqGroup?.hasSubcategories ? (
									<div
										className='faq-group'
										key={faqGroup._id}
									>
										{faqGroup.subcategories.map(
											(subcategory, idx) => {
												return (
													<div
														className='faq-subgroup'
														key={subcategory._key}
													>
														<div>
															<h4 className='heading-s'>
																{
																	subcategory.subcategoryName
																}
															</h4>
														</div>
														<div className='faq-subgroup-items'>
															{subcategory?.faqItems?.map(
																(faqItem) => {
																	return (
																		<FaqItem
																			faq={
																				faqItem
																			}
																			idx={
																				idx
																			}
																			key={
																				faqItem._id
																			}
																			faqClickHandler={
																				faqClickHandler
																			}
																		/>
																	);
																}
															)}
														</div>
													</div>
												);
											}
										)}
									</div>
								) : (
									faqGroup?.faqItems?.map((faqItem) => {
										return (
											<FaqItem
												faq={faqItem}
												key={faqItem._id}
												faqClickHandler={
													faqClickHandler
												}
											/>
										);
									})
								)}
							</div>
						);
					})}
				</div>
			</div>
		</>
	);
}
